import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WebSocketState, LiveSignalData } from '../../types/websocket';

export interface WebSocketSliceState {
  connections: {
    [facilityId: number]: WebSocketState;
  };
  liveSignalData: {
    [facilityId: number]: LiveSignalData;
  };
  globalError: string | null;
}

const initialState: WebSocketSliceState = {
  connections: {},
  liveSignalData: {},
  globalError: null
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setConnectionState: (state, action: PayloadAction<{ facilityId: number; state: WebSocketState }>) => {
      const { facilityId, state: connectionState } = action.payload;
      if (connectionState.isConnected) {
        state.globalError = null;
      }
      state.connections[facilityId] = connectionState;
    },
    
    setLiveSignalData: (state, action: PayloadAction<{ facilityId: number; data: LiveSignalData }>) => {
      const { facilityId, data } = action.payload;
      state.liveSignalData[facilityId] = data;
    },
    
    clearLiveSignalData: (state, action: PayloadAction<number>) => {
      const facilityId = action.payload;
      delete state.liveSignalData[facilityId];
    },
    
    removeConnection: (state, action: PayloadAction<number>) => {
      const facilityId = action.payload;
      delete state.connections[facilityId];
      delete state.liveSignalData[facilityId];
    },
    
    setGlobalError: (state, action: PayloadAction<string | null>) => {
      state.globalError = action.payload;
    },
    
    clearAllConnections: (state) => {
      state.connections = {};
      state.liveSignalData = {};
      state.globalError = null;
    }
  }
});

export const {
  setConnectionState,
  setLiveSignalData,
  clearLiveSignalData,
  removeConnection,
  setGlobalError,
  clearAllConnections
} = websocketSlice.actions;

export default websocketSlice.reducer; 